import styled from 'styled-components/macro';

export const JobListBlockTextContainer = styled.div`
  padding: 1rem;
  width: 100%;
`;
